var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbrellaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.75C7.5 17.5511 7.42098 17.3603 7.28033 17.2197C7.13968 17.079 6.94891 17 6.75 17C6.55109 17 6.36032 17.079 6.21967 17.2197C6.07902 17.3603 6 17.5511 6 17.75H7.5ZM10 10.75V18.75H11.5V10.75H10ZM7.5 18.75V17.75H6V18.75H7.5ZM10.75 11.5H20.274V10H10.75V11.5ZM11.226 0H10.274V1.5H11.226V0ZM1.226 11.5H10.75V10H1.226V11.5ZM0 10.274C0 10.951 0.549 11.5 1.226 11.5V10C1.377 10 1.5 10.123 1.5 10.274H0ZM21.5 10.274C21.5 4.6 16.9 0 11.226 0V1.5C12.3782 1.5 13.5192 1.72695 14.5837 2.16788C15.6482 2.60882 16.6154 3.2551 17.4302 4.06985C18.2449 4.88459 18.8912 5.85182 19.3321 6.91634C19.7731 7.98085 20 9.12178 20 10.274H21.5ZM20.274 11.5C20.951 11.5 21.5 10.951 21.5 10.274H20C20 10.123 20.123 10 20.274 10V11.5ZM8.75 20C8.06 20 7.5 19.44 7.5 18.75H6C6 19.4793 6.28973 20.1788 6.80546 20.6945C7.32118 21.2103 8.02065 21.5 8.75 21.5V20ZM10.274 0C4.6 0 0 4.6 0 10.274H1.5C1.5 7.94699 2.4244 5.71529 4.06985 4.06985C5.71529 2.4244 7.94699 1.5 10.274 1.5V0ZM10 18.75C10 19.44 9.44 20 8.75 20V21.5C9.47935 21.5 10.1788 21.2103 10.6945 20.6945C11.2103 20.1788 11.5 19.4793 11.5 18.75H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6649 10.75C15.3849 8.039 14.3049 0.75 10.7499 0.75C7.19494 0.75 6.11494 8.039 5.83594 10.75",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrellaIcon);
export default __webpack_public_path__ + "static/media/umbrella_icon.78cb935e5dc5e543053eb8e1de1cdcda.svg";
export { ForwardRef as ReactComponent };